module.exports = __webpack_public_path__ + "img/rank-title.ca4344b4.png";